import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  QaiButtonComponent,
  QaiCallButtonComponent,
  QaiIconComponent,
} from '@qai/ui';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  imports: [
    CommonModule,
    MatTooltipModule,
    QaiButtonComponent,
    QaiCallButtonComponent,
    QaiIconComponent,
    TranslocoModule
  ],

  selector: 'app-visual-aid-call-controls',
  standalone: true,
  templateUrl: './visual-aid-call-controls.component.html',
  styleUrls: ['./visual-aid-call-controls.component.scss'],
})
export class VisualAidCallControlsComponent {
  @Input({ required: true }) isMicOn = false;
  @Input({ required: true }) isPaused = false;
  @Input() disableMicButton = false;
  @Input() disableEndCallButton = false;
  @Input() isPauseEnabled = true;
  @Input() showPauseButton = true;

  @Output() readonly microphoneClicked = new EventEmitter();
  @Output() readonly endCallClicked = new EventEmitter();
  @Output() readonly playbackClicked = new EventEmitter();

  protected handlePlaybackClick() {
    this.playbackClicked.emit();
  }
  protected handleMicrophoneClick() {
    this.microphoneClicked.emit();
  }
  protected handleEndCallClick() {
    this.endCallClicked.emit();
  }
}
